// import router from "@/router";
import api from "@/api/contestApi";
import authSerivce from "@/services/contest/auth";
import videosService from "@/services/contest/videos";
import showAlert from "@/services/common/showAlert";
import { openModal as showProfile } from "@/components/contest/user/ContestProfile";

window.contestApi = api;

const state = {
  token: localStorage.getItem("contest-user-token") || "",
  status: null,
  currentUser: null
};

const getters = {
  authStatus: s => s.status,
  isAuthenticated: s => !!s.currentUser,
  isAuthLoading: s => s.status === "loading",
  user: ({ currentUser }) => {
    if (currentUser) {
      const { first_name, last_name } = currentUser || {};
      Object.assign(currentUser, {
        nickname: `${first_name} ${last_name}`
      });
    }
    return currentUser;
  }
};

const mutations = {
  authRequest(state) {
    state.status = "loading";
  },
  authSuccess(state, user) {
    state.status = "success";
    state.currentUser = user;
  },
  authError(state) {
    state.status = "error";
  },
  authLogout(state) {
    state.token = "";
    state.currentUser = null;
  },
  setToken(state, newValue) {
    state.token = newValue;
  },
  setUser(state, user) {
    state.currentUser = user;
  },
  updateUser(state, userData) {
    state.currentUser = Object.assign({}, state.currentUser, userData);
  }
};

const actions = {
  async init({ state, dispatch }) {
    if (state.token) {
      setDefaultAuthHeaders(state.token);
      await dispatch("getProfile");
    }
  },

  async setToken({ commit }, token) {
    token = token || "";
    token && localStorage && localStorage.setItem("contest-user-token", token);
    !token && localStorage && localStorage.removeItem("contest-user-token");
    commit("setToken", token);
    setDefaultAuthHeaders(token);
  },

  async signup({ dispatch }, data) {
    const result = await authSerivce.signup(data);
    if (result.success) {
      const credentials = {
        email: data.email,
        password: data.password
      };
      await dispatch("login", credentials);
    }
    return result;
  },

  async login({ commit, dispatch }, credentials) {
    try {
      commit("authRequest");
      const { success, message, data } = await authSerivce.login(credentials);

      if (!success) {
        commit("authError");
        return { success, message, data };
      }

      const token = data.token;
      await dispatch("setToken", token);
      await dispatch("getProfile");

      return { success, message, data };
    } catch {
      showAlert("Ошибка авторизации");
    }
  },

  logout({ commit }) {
    commit("authLogout");
    localStorage.removeItem("contest-user-token");
    setDefaultAuthHeaders("");
  },

  async getProfile({ commit, dispatch }) {
    let result = false;
    commit("authRequest");
    try {
      const { data, success } = await authSerivce.getProfile();
      if (success) {
        commit("authSuccess", data);
        result = data;
      }
    } finally {
      if (!result) {
        commit("authError");
        await dispatch("logout");
      }
    }
    return result;
  },

  async refreshProfile({ commit, dispatch }) {
    try {
      const { success, data } = await authSerivce.getProfile();
      if (success) commit("setUser", data);
      else await dispatch("logout");
    } catch {
      await dispatch("logout");
    }
  },

  async updateProfile({ dispatch }, data) {
    const result = await authSerivce.signup(data);
    if (result.success) {
      dispatch("refreshProfile");
    }
    return result;
  },

  async openProfile({ getters }) {
    const { data: record } = await videosService.getMyRecord();
    console.log(record);
    await showProfile(getters.user, record);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function setDefaultAuthHeaders(token) {
  if (token) {
    api.defaults.headers.common.Authorization = "Bearer " + token;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}
